import { z } from 'zod';
import { isoDateString } from './common.schema';

/** True only when the YYYY-MM-DD string is a real calendar date (no Date normalization). */
function isRealCalendarDate(isoDate: string): boolean {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(isoDate.trim());
  if (!m) return false;
  const year = Number(m[1]);
  const month = Number(m[2]);
  const day = Number(m[3]);
  const d = new Date(year, month - 1, day);
  return (
    d.getFullYear() === year && d.getMonth() === month - 1 && d.getDate() === day
  );
}

function isNotFutureDateOnly(isoDate: string): boolean {
  if (!isRealCalendarDate(isoDate)) return false;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(isoDate.trim());
  if (!m) return false;
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return d.getTime() <= today.getTime();
}

export const intakeDemographicsSchema = z.object({
  firstName: z.string().trim().min(1, 'Required').max(100, 'First name is too long'),
  lastName: z.string().trim().min(1, 'Required').max(100, 'Last name is too long'),
  email: z.string().trim().min(1, 'Email is required').email('Enter a valid email'),
  dateOfBirth: isoDateString
    .refine(isRealCalendarDate, 'Enter a valid date')
    .refine(isNotFutureDateOnly, 'Date of birth cannot be in the future'),
  zip: z.string().regex(/^\d{5}$/, 'Enter a valid 5-digit ZIP code'),
});

export type IntakeDemographicsInput = z.infer<typeof intakeDemographicsSchema>;
